<template>
  <div class="fixed-top menucontrol-scroll">
    <Banner />
    <TestimonialTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import TestimonialTable from "./components/TestimonialTable.vue";
export default {
  components: {
    Banner,
    TestimonialTable,
  },
};
</script>
